/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { trackEvent as track } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { CircularProgress, makeStyles } from '@material-ui/core';
import { bool, func, object, string } from 'prop-types';
import findCategoryById from '../../../../../gql/queries/findCategoryById';
import { GRAPHQL_ENV } from '../../../../../gql';
import { useSelector } from 'react-redux';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import ResponsiveImage from '../../../../../components/GraphqlComponents/GraphqlCommonComponents/ResponsiveImage/ResponsiveImage';
import GenericSkeleton from '../../../../../components/GraphqlComponents/GraphqlSkeletonComponents/GenericSkeleton';
import { isMobile } from 'react-device-detect';
import html2canvas from 'html2canvas';

import BrandLogo from './assets/BrandLogo';
import Carousel from './Common/Carousel';
import DadJokeResultPageTopBg from './assets/dadjokegpt/DadJokeResultPageTopBg';
import DadJokeResultPageBottomBg from './assets/dadjokegpt/DadJokeResultPageBottomBg';
import DadJokeSavedImageTopBg from './assets/dadjokegpt/DadJokeSavedImageTopBg';
import DadJokeSavedImageBottomBg from './assets/dadjokegpt/DadJokeSavedImageBottomBg';
import { useUIDSeed } from 'react-uid';
import { Link } from 'react-router-dom';
import { Query } from '@apollo/client/react/components';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import Disclaimer from './Common/Disclaimer';
import SocialMedia from './SocialMedia';
import DadJokeOfTheDay from './Common/DadJokeOfTheDay';
import Icons from './assets/Icons';
import { RecommendedProduct } from './Common/RecommendedProduct';
import { ProductCard } from './Common/ProductCard';
import { getAccessTokenSafely } from '../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import { getProfileInfo } from '../../../state/Selectors';
import { useMutation } from 'react-query';
import composePersonalizedContent from '../../../../../../apis/chatgpt-apis/composePersonalizedContent';

const useStyles = (mobile, isDadJokeGPT) =>
    makeStyles((theme) => ({
        contentContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',
            zIndex: '2',
            height: '100%',
            width: '100%',
            maxWidth: '715px',
            padding: '24px 0 12px 0',
            overflow: 'hidden',
            '& > h2': {
                color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}!important`,
                textAlign: 'center',
                fontWeight: '700 !important',
                fontSize: '16px !important',
                lineHeight: '24px',
                textTransform: 'none !important',
                margin: `${mobile ? '0 0 16px 0' : '0 0 32px 0'} !important`,
            },
        },
        logoButton: {
            float: 'none !important',
            margin: '0 0 16px 0 !important',
            padding: '0 !important',
            border: '0 !important',
            backgroundColor: 'unset !important',
            borderRadius: 'unset !important',
            minWidth: 'unset !important',
            maxWidth: '100%',
        },
        logo: {
            maxWidth: '100%',
            width: !isDadJokeGPT && !mobile ? '450px' : undefined,
        },
        poemResultContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '8px',
            padding: isDadJokeGPT ? '35px 30px' : '24px 30px',
            margin: '12px 0 24px 0',
            width: '100%',
            height: '100%',
            backgroundColor: `${theme.palette.common.white}`,
            color: `${theme.palette.common.black} !important`,
            textAlign: 'center',
            lineHeight: '28px',
            '& > span': {
                fontFamily: 'Dosis, sans-serif',
                color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}!important`,
            },
            '& > span:first-child': {
                fontFamily: `${isDadJokeGPT ? 'Dela Gothic One, cursive' : 'Dosis, sans-serif'}`,
                color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}!important`,
            },
            '& > p': {
                margin: 0,
                fontSize: `${mobile ? '16px' : '18px'} !important`,
                fontFamily: 'Lato, sans-serif',
                fontWeight: `${isDadJokeGPT ? 400 : 500}`,
                lineHeight: '28px',
                color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}!important`,
                overflowWrap: 'break-word',
            },
        },
        optionContainer: {
            display: 'flex',
            gap: '24px',
            '& > *': {
                position: 'relative',
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                textDecoration: 'none',
                fontStyle: 'normal',
                color: `${isDadJokeGPT ? '#081E3F' : `#F55858`}`,
                fontSize: `${mobile ? '14px' : '16px'} !important`,
                lineHeight: mobile ? '20px' : '26px',
                fontWeight: 700,
                cursor: 'pointer',
                marginBottom: '10px',
                borderBottom: `2px solid ${isDadJokeGPT ? '#081E3F' : `#F55858`}`,
            },
            '& > i': {
                '& svg': {
                    maxWidth: '16px',
                },
            },
        },
        downloadDisabled: {
            color: 'rgba(85, 85, 85, 0.25)',
            borderBottom: '2px solid rgba(85, 85, 85, 0.25)',
            pointerEvents: 'none',
        },
        poemImageWrapper: {
            position: 'absolute',
            left: '-9999px',
            width: '378px !important',
            height: '611px !important',
        },
        poemImageContainer: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            zIndex: 1000,
            borderRadius: 0,
            margin: 0,
            background: `${
                isDadJokeGPT
                    ? 'linear-gradient(180deg, rgba(16, 124, 223, 0.584) -16.53%, rgba(92, 215, 232, 0) 38.78%, rgba(85, 183, 77, 0.8) 116.2%)'
                    : 'linear-gradient(180deg, #F9EDE1 0%, #F8D7D7 90%)'
            }`,
            padding: '20px 30px 35px 30px',
            '& > *': {
                zIndex: 1200,
            },
            '& > p': {
                fontSize: `16px !important`,
            },
            '& > p:last-of-type': {
                marginBottom: '30px',
            },
        },
        poemImageHeader: {
            display: 'flex',
            flexDirection: isDadJokeGPT ? 'row' : 'column',
            gap: '12px',
            justifyContent: 'center',
            alignItems: isDadJokeGPT ? 'baseline' : 'center',
            minWidth: '100%',
        },
        poemImageText: {
            display: 'flex',
            gap: '10px',
            margin: '0',
            fontWeight: `${isDadJokeGPT ? 700 : 600}`,
            fontStyle: 'normal',
            lineHeight: '28px',
            color: `${isDadJokeGPT ? '#081E3F' : '#375326'}`,
            fontFamily: `Lato, sans-serif !important`,
        },
        poemImageFooter: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            '& > span': {
                display: 'flex',
                margin: 0,
            },
        },
        poemFor: {
            fontSize: `${isDadJokeGPT ? (mobile ? '24px' : '32px') : mobile ? '18px' : '20px'} !important`,
            fontWeight: 700,
            color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black}!important`,
            lineHeight: mobile ? '26px' : '32px',
            textTransform: isDadJokeGPT ? 'uppercase' : 'capitalize',
            marginBottom: mobile ? '34px' : '24px',
            fontFamily: `${isDadJokeGPT ? 'Dela Gothic One, cursive' : 'Lato, sans-serif'} !important`,
        },
        poemForImage: {
            margin: '15px 0 24px 0',
            fontFamily: `${isDadJokeGPT ? 'Dela Gothic One, cursive' : 'Lato, sans-serif'}`,
        },
        spacer: {
            margin: '12px 0',
        },
        botTitle: {
            marginTop: '28px',
            fontSize: '16px !important',
            fontFamily: `${isDadJokeGPT ? 'Lato, sans-serif !important' : 'inherit'}`,
            fontStyle: `${isDadJokeGPT ? 'bold !important' : 'inherit'}`,
            fontWeight: `${isDadJokeGPT ? 700 : 600}`,
            lineHeight: '28px',
            marginBottom: '16px',
        },
        party: {
            margin: '15px 0',
            width: '46px',
        },
        buttonWrapper: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '10px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        buttonContainer: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
        },
        button: {
            width: '155px !important',
            height: '36px',
            borderRadius: '3px !important',
            margin: '0 0 12px 0 !important',
            fontSize: '14px !important',
            lineHeight: '20px',
            textTransform: 'none !important',
            backgroundColor: `${isDadJokeGPT ? theme.palette.common.white : '#F55858'} !important`,
            border: `1px solid ${isDadJokeGPT ? '#081E3F' : '#F55858'} !important`,
            letterSpacing: '0.04em',
            color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.white}!important`,
            fontWeight: '700 !important',
            padding: '6px 12px !important',
            whiteSpace: 'nowrap',
            '&:disabled': {
                color: '#C4C4C4 !important',
                border: `1px solid #C4C4C4 !important`,
                backgroundColor: `${theme.palette.common.white} !important`,
            },
        },
        secondaryButton: {
            border: '1px solid #F55858 !important',
            color: '#F55858 !important',
            backgroundColor: `${theme.palette.common.white} !important`,
        },
        shareButton: {
            fontFamily: 'Lato, sans-serif !important',
            width: `${mobile ? 200 : 260}px !important`,
            height: `${mobile ? 36 : 50}px !important`,
            borderRadius: '3px !important',
            margin: '10px 0 0 0 !important',
            fontSize: `${mobile ? 14 : 18}px !important`,
            lineHeight: '20px',
            textTransform: 'capitalize !important',
            backgroundColor: `${theme.palette.common.white} !important`,
            letterSpacing: '0.04em',
            color: `${theme.palette.common.black} !important`,
            border: `1px solid ${theme.palette.common.black} !important`,
            fontWeight: '700 !important',
            '& > span': {
                fontSize: `${mobile ? 14 : 18}px !important`,
            },
        },
        carouselContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            zIndex: '2',
            height: '100%',
            width: '100%',
            marginBottom: '24px',
            '& img': {
                borderRadius: '8px',
                maxWidth: '100%',
            },
            '& h3': {
                color: `${theme.palette.common.black} !important`,
                textAlign: 'center',
                fontWeight: '700 !important',
                fontSize: `${mobile ? '20px' : '24px'} !important`,
                lineHeight: `${mobile ? '30px' : '36px'} !important`,
                maxWidth: mobile ? '40ch' : '',
                margin: '0 0 16px 0 !important',
            },
        },
        shareContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            zIndex: '2',
            marginBottom: '24px',
            '& > h3': {
                color: `${theme.palette.common.black} !important`,
                textAlign: 'center',
                fontWeight: '700 !important',
                fontSize: `${mobile ? '20px' : '24px'} !important`,
                lineHeight: `${mobile ? '30px' : '36px'} !important`,
                margin: '0 0 16px 0 !important',
                maxWidth: mobile ? '40ch' : '',
            },
        },
        icon: {
            maxHeight: '29px',
            height: '16px',
            width: '14px',
            color: `${isDadJokeGPT ? '#081E3F' : theme.palette.common.black} !important`,
            filter: `${
                !isDadJokeGPT
                    ? 'invert(55%) sepia(40%) saturate(5307%) hue-rotate(329deg) brightness(103%) contrast(92%)'
                    : 'none'
            }`,
        },
        imageIcon: {
            filter: `${
                !isDadJokeGPT
                    ? 'invert(55%) sepia(40%) saturate(5307%) hue-rotate(329deg) brightness(103%) contrast(92%)'
                    : 'none'
            }`,
        },
        shopAndSend: {
            textDecorationLine: 'underline',
            textUnderlineOffset: '5px',
            color: `${theme.palette.common.black}`,
        },
        MothersDayShopButtonUIContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            [theme.breakpoints.down(366)]: {
                flexWrap: 'wrap',
            },
        },
        MothersDayShopButtonUIImg: {
            borderRadius: '8px',
            zIndex: '10',
            width: 330,
            height: 197,
            [theme.breakpoints.down('sm')]: {
                width: 156,
                height: 144,
            },
        },
        MothersDayShopButtonUITextContainer: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '24px',
            alignSelf: 'center',
            alignItems: 'start',
            zIndex: '10',
            width: 338,
            height: 'auto',
            [theme.breakpoints.down('sm')]: {
                width: 200,
            },
            [theme.breakpoints.down(366)]: {
                flexWrap: 'wrap',
                marginLeft: '0px',
                alignItems: 'center',
                padding: '8px',
                textAlign: 'center',
            },
        },
        MothersDayShopButtonUIText: {
            fontStyle: 'normal',
            fontWeight: 700,
            marginTop: '0px',
            marginBottom: '8px',
            color: '#000000!important',
            fontSize: '24px!important',
            lineHeight: '36px',
            [theme.breakpoints.down('sm')]: {
                fontSize: '16px!important',
                lineHeight: '24px',
            },
        },
        MothersDayShopButtonUILink: {
            textDecoration: 'none',
        },
        MothersDayShopButtonUIBtn: {
            backgroundColor: '#000000!important',
            color: 'white',
            border: '1px solid black!important',
            padding: '6px 12px!important',
            borderRadius: '3px!important',
            width: '225px',
            '&:hover': {
                backgroundColor: '#333',
            },
            '& > span': {
                fontSize: '16px!important',
                [theme.breakpoints.down('sm')]: {
                    fontSize: '14px!important',
                },
            },
            [theme.breakpoints.down('sm')]: {
                width: 'auto',
            },
        },
        resultPageTop: {
            width: '100vw',
            height: '100%',
            zIndex: 1,
            overflow: 'hidden',
            position: 'absolute',
            maxWidth: '100vw',
            '& img': {
                top: '-550px', // No BG on Mobileds
                width: '100%',
                maxWidth: '1976px',
                height: '1235px',
                position: 'absolute',
            },
        },
        resultPageBottom: {
            width: '100vw',
            height: '100%',
            zIndex: 1,
            overflow: 'hidden',
            position: 'absolute',
            maxWidth: '100vw',
            '& img': {
                width: '100%',
                bottom: `${mobile ? '-600px' : '-700px'}`,
                height: '1040px',
                position: 'absolute',
            },
        },
        error: {
            textAlign: 'center !important',
            fontWeight: '400',
            fontSize: '14px !important',
            lineHeight: '20px',
            color: '#DF3030',
            margin: '0 !important',
            marginBottom: '12px !important',
        },
        savedImageTop: {
            position: 'absolute',
            top: 0,
            left: 0,
        },
        savedImageBottom: {
            position: 'absolute',
            bottom: '-9px',
            left: 0,
        },
    }));

const PoemResultPage = ({
    mobile,
    poem,
    recipient,
    previousEnabled,
    previousMomVerseEnabled,
    handleResetPoem,
    handleSetPreviousPoem,
    handleSetPreviousPoemMomVerse,
    trackEvent,
    isDadJokeGPT,
    occasion,
    handlePoemMutationSuccess,
    handlePoemMutationError,
    selections,
    error,
    setError,
    setRecipient,
}) => {
    const classesLayout = useStyles(mobile, isDadJokeGPT);
    const classes = classesLayout();
    const [isPoemCopied, setIsPoemCopied] = useState(false);
    const [retries, setRetries] = useState(3);

    const createPoemMutation = useMutation({
        mutationFn: composePersonalizedContent,
        onSuccess: ({ data: { poem, isSuccessful } }) =>
            handlePoemMutationSuccess(poem, isSuccessful, () => {
                if (isDadJokeGPT) return;
                setRecipient(selections?.forMy ?? '');
                setRetries(retries - 1);
            }),
        onError: handlePoemMutationError,
    });

    const brand = useSelector(getBrand);
    const featureFlags = useSelector(getFeatureFlags);
    const profileInfo = useSelector(getProfileInfo);

    const poemImageRef = useRef(null);
    const timeoutRef = useRef(null);

    const seed = useUIDSeed();
    const productQuery = findCategoryById();

    const isDadJokeProductButtonEnabled = featureFlags?.['is-dad-joke-page-product-button-enabled'];
    const whichPoemPageProductVariantToDisplay = featureFlags?.['which-poem-page-product-variation-to-display'];
    const isDadJokeOfTheDayEnabled = featureFlags?.['is-dad-joke-otd-enabled'];
    const isNewButtonFlowEnabled = featureFlags?.['is-poem-page-new-button-flow-enabled'];
    const { button: buttonUIABTest, carousel: carouselUIABTest } = whichPoemPageProductVariantToDisplay;
    const isPoemDownloadEnabled = featureFlags?.['is-poem-page-download-enabled'];

    const MomVerseDesktop =
        'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcdaf24cfa8192ed8/66104d69ca5a97909a554be3/MomVerse-MobileV2.svg';
    const MomVerseMobile =
        'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltcdaf24cfa8192ed8/66104d69ca5a97909a554be3/MomVerse-MobileV2.svg';

    const responsiveImagePath = (name, path) => {
        const extension = (name || '').includes('_gif') ? '.gif' : 'x.jpg';
        return `${path + name + extension}`;
    };

    const handleCtaTracking = (action = '', label = '') => {
        trackEvent({
            eventCategory: occasion,
            eventAction: action,
            eventLabel: label,
        });
    };

    const handleCopyClick = () => {
        if (
            typeof navigator !== 'undefined' &&
            typeof navigator.clipboard !== 'undefined' &&
            typeof navigator.permissions !== 'undefined'
        ) {
            navigator.clipboard.writeText(poem);
            setIsPoemCopied(true);
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
                setIsPoemCopied(false);
            }, 3000);
        }
    };

    const getDataUrl = async () => {
        if (typeof window === 'undefined' || !window || !poemImageRef.current) return;
        window.scrollTo(0, 0);
        const canvas = await html2canvas(poemImageRef.current, {
            scrollX: -window.scrollX,
            scrollY: -window.scrollY,
            scale: 2,
        });
        const dataUrl = canvas.toDataURL('image/png');
        return dataUrl || '';
    };

    const handleDownloadImage = async () => {
        const dataUrl = await getDataUrl();
        const link = document.createElement('a');
        link.download = 'poem-image.png';
        link.href = dataUrl;
        link.click();
        link.remove();
    };

    const handleComposeAgain = async () => {
        if (retries <= 0) return;
        const { forMy, whoLikes, writeA } = selections;
        const token = await getAccessTokenSafely();
        const captcha = '';
        const interests = Object.values(whoLikes).filter((interest) => !!interest);
        const occasion = isDadJokeGPT ? "Father's Day" : "Mother's Day";
        setError('');
        createPoemMutation.mutate({
            token,
            brand: brand?.description || '1-800-Flowers',
            interests,
            enforceCharacterLimit: false,
            recipient: forMy,
            userId: profileInfo?.email || '',
            verseType: isDadJokeGPT ? writeA : 'Poem',
            captchaToken: captcha,
            occasion,
        });
    };

    const getBrandDetails = (brandCode) => {
        const brandDetailsForMomverse = {
            CCO: {
                id: 'MBP-CCO-Occasions~Mothers Day',
                href: '/mothers-day-cookie-gifts',
            },
            '18F': {
                id: '10373',
                href: '/mothers-day-best-sellers',
            },
            HD: {
                id: 'mothers-day-best-sellers-hd',
                href: '/h/mothers-day-gifts/mothers-day-best-sellers',
            },
            TPF: {
                id: 'MBP-TPF-Occasions~MothersDay',
                href: '/mothers-day-gifts',
            },
            WLF: {
                id: 'mothers-day-gifts-wlf',
                href: '/w/mothers-day-gifts',
            },
            SCH: {
                id: 'MBP-SC-Occasions-Mothers Day',
                href: '/mothers-day-chocolate-gifts',
            },
            BRY: {
                id: 'BRY-Mothers Day-400214590',
                href: '/mothers-day-gifts-sm1',
            },
            FB: {
                id: 'FB-Mothers-Day-400113016',
                href: '/mothers-day-fruit-arrangements-400113016',
            },
            '18B': {
                id: '11210',
                href: '/mothers-day-gift-baskets-11210',
            },
        };
        const brandDetailsForDadJoke = {
            CCO: {
                id: 'MBP-CCO-Occasions~Fathers-Day',
                href: '/fathers-day-cookie-gifts',
            },
            '18F': {
                id: '10383',
                href: '/fathersday',
            },
            HD: {
                id: 'fathers-day-gifts-hd',
                href: '/h/fathers-day-gifts/all',
            },
            TPF: {
                id: 'MBP-TPF-Occasions~FathersDay',
                href: '/fathers-day-gifts',
            },
            WLF: {
                id: 'fathers-day-gifts-wlf',
                href: '/w/fathers-day-gifts',
            },
            SY: {
                id: 'fathers-day-gifts-sy',
                href: '/s/fathers-day-gifts',
            },
            SCH: {
                id: 'MBP-SC-Occasions-Fathers-Day',
                href: '/fathers-day-chocolate',
            },
            BRY: {
                id: 'BRY-Fathers Day Gifts-400217110',
                href: '/fathers-day-gifts-sf1',
            },
            FB: {
                id: 'FB-Fathers Day-400116005',
                href: '/fathers-day-fruit-arrangements-400116005',
            },
            '18B': {
                id: '11176',
                href: '/fathers-day-gift-baskets-11176',
            },
            VC: {
                id: 'fathers-day-vc',
                href: '/v/occasion-gifting/fathers-day',
            },
        };
        return isDadJokeGPT ? brandDetailsForDadJoke[brandCode] : brandDetailsForMomverse[brandCode];
    };

    const fallbackLink = isDadJokeGPT ? '/h/fathers-day-gifts/all' : '/mothers-day-best-sellers';
    const brandData = getBrandDetails(brand?.code);

    const renderProductsCarousel = ({ brand, mobile, isDadJokeGPT = false }) => {
        const skeletons = GenericSkeleton({ height: mobile ? 97 : 167, width: mobile ? 88 : 152, repeatCount: 8 });
        const linkTitle = isDadJokeGPT
            ? "Shop and send a Father's Day gift with your dad joke today!"
            : "Shop and send a Mother's Day gift with your poem today!";
        return (
            <Query
                query={productQuery}
                variables={{
                    brand: brand?.domain,
                    environment: GRAPHQL_ENV,
                    locale: 'en-us',
                    id: brandData?.id || (isDadJokeGPT ? 'fathers-day-gifts-hd' : '10373'),
                    productOptions: {
                        orderBy: 'BEST_SELLERS',
                        pageSize: 8,
                        page: 1,
                    },
                }}
            >
                {({ data, loading }) => {
                    const products = data?.findCategoryById?.products;
                    return (
                        <div className={classes.carouselContainer}>
                            <Link
                                to={brandData?.href || fallbackLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.shopAndSend}
                            >
                                <h3 onClick={() => handleCtaTracking('CTA Click', linkTitle)}>{linkTitle}</h3>
                            </Link>
                            <Carousel products length={8} slideWidth={mobile ? 112 : 170} mobile={mobile}>
                                {loading && skeletons.map((skeleton) => skeleton)}
                                {!loading &&
                                    !!products &&
                                    products.map((product) => (
                                        <div
                                            key={seed(product)}
                                            onClick={() => handleCtaTracking('PDP Click', product.name)}
                                        >
                                            <Link to={product?.seo?.url} target="_blank" rel="noopener noreferrer">
                                                <ResponsiveImage
                                                    className=""
                                                    alt={product?.name}
                                                    path={responsiveImagePath(
                                                        product?.image?.name,
                                                        product?.image?.path
                                                    )}
                                                    params={{ desktop: 'quality=50', mobile: 'quality=30' }}
                                                />
                                            </Link>
                                        </div>
                                    ))}
                            </Carousel>
                        </div>
                    );
                }}
            </Query>
        );
    };

    const recipientText = recipient === 'Wife' ? `My ${recipient}` : recipient;
    const renderProductsMomVerse = ({ mobile }) => {
        return (
            <>
                <RecommendedProduct
                    mobile={mobile}
                    title={`Handmade Bouquets for ${recipientText}`}
                    campaignFeature="Momverse Floral"
                />
                <RecommendedProduct
                    mobile={mobile}
                    title={`Unique Gifts for ${recipientText}`}
                    campaignFeature="Momverse Non-Floral"
                />
                <ProductCard
                    mobile={mobile}
                    handleProductClick={() => handleCtaTracking('CardIsle Click', 'Redirect ~ /send-greeting-cards')}
                    title={`A Personalized Card For ${recipientText}`}
                    pricePriceText="From $5.99"
                    imageSrc="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt4bafb998596b3722/661d47f816c12059a75dc543/0cd653e364c84c3ca945bdcca8d94d8a.jpg"
                    pdpLink="/send-greeting-cards?cardisle_tags=mother%27s%20day"
                />
            </>
        );
    };

    const renderProducts = (isDadJokeGPT = false) =>
        isDadJokeGPT ? renderProductsCarousel({ brand, mobile, isDadJokeGPT }) : renderProductsMomVerse({ mobile });

    const renderPoem = () =>
        poem.split('\n').map((str, ind) => {
            if (!str) return <br key={`poem-part-break-${seed(ind)}`}></br>;
            return <p key={`poem-part-${seed(str)}`}>{str}</p>;
        });

    useEffect(() => {
        setError('');
        if (typeof window !== 'undefined') window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!isDadJokeGPT) {
            if (buttonUIABTest) {
                trackEvent({
                    eventCategory: 'Test Impression',
                    eventAction: 'Momverse Button Footer',
                    eventLabel: `Variant - ${isMobile ? 'Mobile' : 'Desktop'}`,
                    nonInteraction: '1',
                });
            } else if (carouselUIABTest) {
                trackEvent({
                    eventCategory: 'Test Impression',
                    eventAction: 'Momverse Carousel Footer',
                    eventLabel: `Control - ${isMobile ? 'Mobile' : 'Desktop'}`,
                    nonInteraction: '1',
                });
            }
        }
    }, []);

    if (isDadJokeGPT) {
        return (
            <>
                {!isMobile && (
                    <div className={classes.resultPageTop}>
                        <DadJokeResultPageTopBg />
                    </div>
                )}
                <div className={classes.contentContainer}>
                    <div className={classes.poemResultContainer}>
                        <span className={classes.poemFor}>{recipient}</span>
                        {renderPoem()}
                        <span className={classes.botTitle}>1-800-Flowers.com DAD JOKE GPT</span>
                        {isMobile && (
                            <SocialMedia getDataUrl={getDataUrl} mobile={mobile} isDadJokeGPT={isDadJokeGPT} />
                        )}
                        <div className={classes.optionContainer}>
                            {
                                <>
                                    <Tooltip open={isPoemCopied} placement="bottom" title="Poem copied!">
                                        <i
                                            onClick={() => {
                                                handleCtaTracking('CTA Click', 'Copy Text', isDadJokeGPT);
                                                handleCopyClick();
                                            }}
                                        >
                                            Copy Text{' '}
                                            <Icons
                                                className={classes.icon}
                                                icon="copyText"
                                                isDadJokeGPT={isDadJokeGPT}
                                            />
                                        </i>
                                    </Tooltip>
                                    {!isMobile && isPoemDownloadEnabled && (
                                        <i
                                            onClick={() => {
                                                handleCtaTracking('CTA Click', 'Save as Image', isDadJokeGPT);
                                                handleDownloadImage();
                                            }}
                                        >
                                            Save as Image <Icons icon="gallery" isDadJokeGPT={isDadJokeGPT} />
                                        </i>
                                    )}
                                </>
                            }
                        </div>
                    </div>
                    <div className={classes.poemImageWrapper}>
                        <div
                            ref={poemImageRef}
                            aria-hidden="true"
                            className={`${classes.poemResultContainer} ${classes.poemImageContainer}`}
                        >
                            <div className={classes.savedImageTop}>
                                <DadJokeSavedImageTopBg />
                            </div>
                            <div className={classes.savedImageBottom}>
                                <DadJokeSavedImageBottomBg />
                            </div>
                            <h4 className={`${classes.poemForImage} ${classes.poemFor}`}>{recipient}</h4>
                            {renderPoem()}
                            <div className={classes.poemImageFooter}>
                                <span className={classes.poemImageText}>
                                    <div className={classes.poemImageHeader}>
                                        <BrandLogo brandId={brand?.code} isDadJokeGPT={isDadJokeGPT} />
                                        <span className={classes.poemImageText}>Compose Yours Now</span>
                                    </div>
                                </span>
                                <span
                                    className={classes.poemImageText}
                                >{`www.${brand?.domain}.com/account/dadjokegpt`}</span>
                            </div>
                        </div>
                    </div>
                    {!isMobile && (
                        <>
                            <h2>Share, recite, and record with others now!</h2>
                            <SocialMedia
                                getDataUrl={getDataUrl}
                                mobile={mobile}
                                poem={poem}
                                isDadJokeGPT={isDadJokeGPT}
                            />
                        </>
                    )}
                    <div className={classes.buttonContainer}>
                        <Button
                            onClick={() => {
                                handleCtaTracking('CTA Click', 'Previous Version', isDadJokeGPT);
                                handleSetPreviousPoem();
                            }}
                            type="button"
                            tabIndex="0"
                            className={classes.button}
                            disabled={!previousEnabled}
                        >
                            Previous Version
                        </Button>
                        <Button
                            onClick={() => {
                                handleCtaTracking('CTA Click', 'Compose Again', isDadJokeGPT);
                                handleResetPoem();
                            }}
                            type="button"
                            tabIndex="0"
                            className={classes.button}
                        >
                            Compose Again
                        </Button>
                    </div>
                    <Disclaimer isDadJokeGPT={isDadJokeGPT} />
                </div>
                {renderProducts(isDadJokeGPT)}
                {isDadJokeProductButtonEnabled && (
                    <div
                        onClick={() => {
                            handleCtaTracking('CTA Click', "Shop Father's Day Gifts", isDadJokeGPT);
                            handleResetPoem();
                        }}
                        className={classes.shareContainer}
                    >
                        <h3>You can record your dad joke and send it with your Fathers's Day gift!</h3>
                        <Link to={brandData?.href || fallbackLink} target="_blank" rel="noopener noreferrer">
                            <Button type="button" tabIndex="0" className={classes.shareButton}>
                                Shop Father's Day Gifts
                            </Button>
                        </Link>
                    </div>
                )}
                {isDadJokeOfTheDayEnabled && <DadJokeOfTheDay mobile={mobile} />}
                <div className={classes.resultPageBottom}>
                    <DadJokeResultPageBottomBg mobile={mobile} />
                </div>
            </>
        );
    }

    return (
        <>
            <div className={classes.contentContainer}>
                <Button
                    className={classes.logoButton}
                    tabIndex="0"
                    onClick={() => {
                        handleCtaTracking('CTA Click', 'Start Over');
                        handleResetPoem();
                    }}
                >
                    <img
                        className={classes.logo}
                        alt="1800flowers.com MomVerse"
                        src={mobile ? MomVerseMobile : MomVerseDesktop}
                    />
                </Button>
                <div className={classes.poemResultContainer}>
                    <span className={classes.poemFor}>{`A Poem For ${recipientText}`}</span>
                    {renderPoem()}
                    <div className={classes.spacer}></div>
                    {isMobile && <SocialMedia getDataUrl={getDataUrl} mobile={mobile} isDadJokeGPT={isDadJokeGPT} />}
                    <div className={classes.optionContainer}>
                        {
                            <>
                                <Tooltip open={isPoemCopied} placement="bottom" title="Poem copied!">
                                    <i
                                        onClick={() => {
                                            handleCtaTracking('CTA Click', 'Copy Text');
                                            handleCopyClick();
                                        }}
                                    >
                                        Copy Text <Icons className={classes.icon} icon="copyText" />
                                    </i>
                                </Tooltip>
                                {!isMobile && isPoemDownloadEnabled && (
                                    <i
                                        onClick={() => {
                                            handleCtaTracking('CTA Click', 'Save as Image');
                                            handleDownloadImage();
                                        }}
                                    >
                                        Save as Image <Icons className={classes.imageIcon} icon="gallery" />
                                    </i>
                                )}
                            </>
                        }
                    </div>
                </div>
                <div className={classes.poemImageWrapper}>
                    <div
                        ref={poemImageRef}
                        aria-hidden="true"
                        className={`${classes.poemResultContainer} ${classes.poemImageContainer}`}
                    >
                        <h4
                            className={`${classes.poemForImage} ${classes.poemFor}`}
                        >{`A Poem For ${recipientText}`}</h4>
                        {renderPoem()}
                        <div className={classes.poemImageFooter}>
                            <span className={classes.poemImageText}>
                                <div className={classes.poemImageHeader}>
                                    <BrandLogo brandId={brand?.code} />
                                </div>
                            </span>
                            <span className={classes.poemImageText}>{`www.${brand?.domain}.com/account/momverse`}</span>
                        </div>
                    </div>
                </div>
                <div className={classes.buttonWrapper}>
                    <div className={classes.buttonContainer}>
                        {isNewButtonFlowEnabled && retries > 0 && (
                            <Button
                                onClick={() => {
                                    handleCtaTracking('CTA Click', 'Compose Again ~ New');
                                    handleComposeAgain();
                                }}
                                type="button"
                                tabIndex="0"
                                className={classes.button}
                                disabled={retries <= 0 || createPoemMutation.isLoading}
                            >
                                {createPoemMutation.isLoading ? (
                                    <CircularProgress style={{ width: '20px', height: '20px' }} />
                                ) : (
                                    'Compose Again'
                                )}
                            </Button>
                        )}
                        {(isNewButtonFlowEnabled && retries <= 0) || !isNewButtonFlowEnabled ? (
                            <Button
                                onClick={() => {
                                    handleCtaTracking('CTA Click', 'Start Over');
                                    handleResetPoem();
                                }}
                                type="button"
                                tabIndex="0"
                                className={classes.button}
                                disabled={createPoemMutation.isLoading}
                            >
                                Start Over
                            </Button>
                        ) : null}
                        <Button
                            onClick={() => {
                                handleCtaTracking('CTA Click', 'Previous Version');
                                handleSetPreviousPoemMomVerse();
                            }}
                            type="button"
                            tabIndex="0"
                            className={`${classes.button} ${classes.secondaryButton}`}
                            disabled={!previousMomVerseEnabled || createPoemMutation.isLoading}
                        >
                            Previous Version
                        </Button>
                    </div>
                    {error && isNewButtonFlowEnabled && <p className={classes.error}>{error}</p>}
                </div>
                {renderProducts()}
                <Disclaimer />
            </div>
        </>
    );
};

PoemResultPage.defaultProps = {
    mobile: false,
    poem: '',
    recipient: '',
    previousEnabled: false,
};

PoemResultPage.propTypes = {
    mobile: bool,
    poem: string,
    recipient: string,
    previousEnabled: bool,
    previousMomVerseEnabled: bool,
    handleResetPoem: func.isRequired,
    handleSetPreviousPoem: func.isRequired,
    handleSetPreviousPoemMomVerse: func.isRequired,
    occasion: string.isRequired,
    error: string.isRequired,
    handlePoemMutationSuccess: func.isRequired,
    handlePoemMutationError: func.isRequired,
    selections: object.isRequired,
    setError: func.isRequired,
    setRecipient: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

const enhance = compose(connect(null, mapDispatchToProps));

export default enhance(PoemResultPage);
